// Centralized gate for resuming WebAudio only after a user gesture
// Many browsers (Chrome, Safari) block AudioContext.start/resume until a gesture.

let gestureArmed = false;
let gestureSeen = false;
const listeners: Array<() => void> = [];

function markGesture() {
  if (gestureSeen) return;
  gestureSeen = true;
  // fire and clear one-shot listeners
  while (listeners.length) {
    const fn = listeners.shift();
    try { fn && fn(); } catch {}
  }
  // remove global handlers
  try { unarmGlobalListeners(); } catch {}
}

function onGestureOnce(cb: () => void) {
  if (gestureSeen) { cb(); return; }
  listeners.push(cb);
  if (!gestureArmed) armGlobalListeners();
}

function armGlobalListeners() {
  if (gestureArmed) return;
  gestureArmed = true;
  ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'click'].forEach((evt) => {
    window.addEventListener(evt, markGesture, { once: true, capture: true });
  });
}

function unarmGlobalListeners() {
  if (!gestureArmed) return;
  gestureArmed = false;
  ['pointerdown', 'mousedown', 'touchstart', 'keydown', 'click'].forEach((evt) => {
    window.removeEventListener(evt, markGesture, { capture: true } as any);
  });
}

export function userGestureSeen(): boolean { return gestureSeen; }

export function armGesture(cb?: () => void) {
  if (cb) onGestureOnce(cb);
  else if (!gestureSeen) armGlobalListeners();
}

export async function resumeCtxOnGesture(ctx: AudioContext): Promise<boolean> {
  if (!ctx) return false;
  if (userGestureSeen()) {
    try { if (ctx.state === 'suspended') { await ctx.resume(); } return true; } catch { return false; }
  }
  return new Promise<boolean>((resolve) => {
    onGestureOnce(async () => {
      try { if (ctx.state === 'suspended') { await ctx.resume(); resolve(true); } else { resolve(true); } }
      catch { resolve(false); }
    });
  });
}
